Namespace 'CustomerVisualMode'

class CustomerVisualMode.DashboardVisualView extends Backbone.View
  template: JST['backbone/templates/customer_visual_mode/customer_visual_mode']
  id: 'customer-visual-mode'

  events:
    'click .owned-session .details': 'openSession'

  initialize: ({configuredWidgets}) ->
    @loadingCollections = new Set
    @sessionViews = {}
    @sessions = new CustomerVisualMode.UserSessions([], {
      defaultFilters: @_defaultFilters()
      filtersFactory: @_filtersFactory()
      accountAttributes: @_accountAttributes()
    })
    @configuredWidgets = configuredWidgets
    @_listenToSessionsEvents()
    @_fetchCollection @sessions
    @_fetchAccountData()
    @tabContainerView = new Common.Sessions.TabContainerView(sessions: @sessions)

  render: =>
    @$el.html(@template())
    @renderTabContainer()
    @renderSessionView()
    @toggleLoading(true)
    @

  renderTabContainer: ->
    @$('#tabs-container').empty().append(@tabContainerView.render().el)

  renderSessionView: (session) =>
    return unless session?.isCurrent()

    factory = new Common.Dashboard.Charts.SessionChartListItemCollectionViewFactory(@configuredWidgets)
    sessionView = @sessionViews[session.cid] ||= new Common.Sessions.SessionView
      session: session
      sessions: @sessions
      filtersFactory: @_filtersFactory()
      chartListItemCollectionViewFactory: factory
    sessionView.render() if sessionView.shouldRerender()
    @$('#sessions-container').detach()
    @$('#customer-visual-content').append(sessionView.el)
    @resetRefreshInterval(session)

  resetRefreshInterval: (session) =>
    clearInterval(@refreshIntervalID) if @refreshIntervalID
    refreshIntervalSeconds = session.get('refresh_interval_in_seconds')
    return if session.isNew() || !refreshIntervalSeconds || parseInt(refreshIntervalSeconds) == 0
    @refreshIntervalID = setInterval(
      => @refreshSession(session),
      refreshIntervalSeconds * 1000
    )

  refreshSession: (session) ->
    session.execute() unless document.hidden

  _listenToSessionsEvents: ->
    @listenTo(@sessions, 'add', @renderSessionView)
    @listenTo(@sessions, 'remove', @removeSessionView)
    @listenTo(@sessions, 'change', @renderSessionView)
    @listenTo(@sessions, 'change:focused', @_onFocus)
    @listenTo @sessions, 'session:pendingFilterChange', @_setLoading
    @listenTo @sessions, 'session:execution:pending', @_setLoading
    @listenTo @sessions, 'session:filterChange', @_removeLoading
    @listenTo @sessions, 'session:execution:finished', @_removeLoading


  _setLoading: ->
    @isLoadingSession = true
    @toggleLoading(@isLoading())

  _removeLoading: ->
    @isLoadingSession = false
    @toggleLoading(@isLoading())

  _fetchAccountData: ->
    @ticketAttributeDefinitions = new AccountSettings.ConversationAttributeCollection()
    @_fetchCollection @ticketAttributeDefinitions
    @teams = new Customer.OperatorGroupCollection()
    @_fetchCollection @teams
    @advisors = new Customer.OperatorCollection()
    @_fetchCollection @advisors, {'user_id': Keepcon.currentUser?.id}
    @subtypes = new Customer.SubtypeCollection()
    @_fetchCollection @subtypes
    @groups = new Customer.GroupCollection()
    @_fetchCollection @groups
    @_createFiltersFactory()
    @sessions.filtersFactory = @_filtersFactory()

  _fetchCollection: (collection, parameters = {}) =>
    @loadingCollections.add(collection)
    collection.fetch
      data: $.param(parameters)
      success: =>
        @loadingCollections.delete(collection)
        @toggleLoading(@isLoading())
      error: -> showError I18n.t('common.session.filters.error')

  isLoading: =>
    @isLoadingSession || @loadingCollections.size != 0

  toggleLoading: (loading) =>
    @sessions.accountAttributes = @_accountAttributes()
    @$el.toggleClass('customer-visual-mode-loading', loading)
    @reorderCharts() unless loading

  reorderCharts: ->
    @sessions.selectedSession().trigger('session:updateChartOrder')

  removeSessionView: (session) =>
    @sessionViews[session.cid]?.remove()
    @sessionViews = _.omit(@sessionViews, session.cid)

  openSession: (event) =>
    listEl = $(event.target).parents('.saved-session')
    id = listEl.data('id')
    @sessions.remove(@sessions.findWhere({focused: true}))
    @sessions.selectSession(@sessions.get(id))

  _filtersFactory: ->
    @filtersFactory ||= @_createFiltersFactory()

  _createFiltersFactory: ->
    @filtersFactory = new CustomerVisualMode.Filters.FiltersFactory
      groups: @groups
      subtypes: @subtypes
      advisors: @advisors
      teams: @teams
      ticketAttributeDefinitions: @ticketAttributeDefinitions

  _defaultFilters: ->
    [
      CustomerVisualMode.Filters.DateFilter
    ]

  _onFocus: (session) ->
    return if session.isNew()
    @refreshSession(session) if session?.isCurrent() and @sessionViews[session.cid]?

  _accountAttributes: ->
    {
      customAttributes: @ticketAttributeDefinitions,
      assignedTeam: @teams,
      assignedAdvisors: @advisors,
      subtypes: @subtypes,
      userGroups: @groups
    }
